import React from "react";
import {Route} from "react-router-dom";
import {combineReducers,createStore} from "redux";
import {Provider} from "react-redux";
import userData from "../Reducers/userData";
import RegisterUser from "./RegisterUser/index";
import HomePage from "./LoginPage/home";
import LoginPage from "./LoginPage";
import UserProfile from "./UserProfile";
import EditProfile from "./EditProfile";
import SearchResults from "./SearchResults";
import Details from "./Details";
import VisitingProfile from "./UserProfile/VisitingProfile";
import AdminPage from "./AdminPage";
import AdminEditProfile from "./AdminPage/adminEditProfile";
import {Restaurant} from "./Restaurant/Restaurant";
import {path} from "express-session/session/cookie";
import restaurantData from "../Reducers/restaurant";
import {bookmark} from "../Services/RestarantDetailsService";
import {RestaurantEdit} from "./ManageRestaurant/RestaurantEdit";


const reducer = combineReducers({users: userData, restaurant: restaurantData })
const store = createStore(reducer);

const Build = () => {
    return(
        <Provider store={store}>
            <>

                <Route path={["/","/home"]}
                        exact={true} component={HomePage}/>

                <Route path={"/register"}
                       exact={true} component={RegisterUser}/>
                <Route path = {"/login"}
                    exact={true} component={LoginPage}/>

                <Route path = {["/userProfile"]}
                       exact={true} component={UserProfile}/>

                <Route path = {"/profile/editProfile"}
                       exact={true} component={EditProfile}/>

                {/*<Route path={"/details/:hid"}*/}
                {/*       exact={true} component={Details}/>*/}

                <Route path={["/search/:searchTerm/:searchName"]}
                       exact={true} component={SearchResults}/>

                <Route path = {"/userProfile/:userId"}
                       exact={true} component={VisitingProfile}/>
                       
                <Route path = {"/profile/admin"}
                        exact={true} component={AdminPage}/>
                        
                <Route path = {"/profile/admin/editProfile"}
                        exact={true} component={AdminEditProfile}/>


                <Route path = {"/business/details"}
                       exact={true} component={RestaurantEdit}/>

                <Route path = {"/details/:restaurantId"}
                       exact={true} component={Restaurant}/>
            </>
        </Provider>
    );
};
export default Build;

